import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Trophy } from "lucide-react";

import { CREAM, INK } from "../components/tournament/PublicParts";
import { publicArchive } from "../lib/tournamentApi";

/** Public results archive for a Director: /d/:handle (team names only). */
export default function DirectorArchive() {
  const { handle } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { publicArchive(handle).then(setD).catch((e) => setError(e.message)); }, [handle]);
  return (
    <div data-testid="director-archive" style={{ background: INK, color: CREAM, minHeight: "100vh", padding: "28px 18px 60px", fontFamily: "system-ui, sans-serif" }}>
      <div style={{ maxWidth: 820, margin: "0 auto" }}>
        {error && <div data-testid="archive-error">{error}</div>}
        {d && (
          <>
            <div style={{ fontSize: 11, letterSpacing: "0.16em", color: "#4db87a", fontWeight: 800 }}>TOURNAMENT ARCHIVE</div>
            <h1 data-testid="archive-title" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 48, margin: "4px 0 20px", lineHeight: 1 }}>{d.director || d.handle}</h1>
            {d.tournaments.map((t) => (
              <Link key={t.slug} to={`/t/${t.slug}/results`} data-testid={`archive-item-${t.slug}`}
                    style={{ display: "block", color: CREAM, textDecoration: "none", borderTop: "0.5px solid rgba(245,240,232,0.15)", padding: "14px 0" }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                  <b style={{ fontSize: 18 }}>{t.name}</b>
                  <span style={{ opacity: 0.6, fontSize: 13 }}>{new Date(t.starts_on).toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" })}</span>
                </div>
                {t.champions.map((c) => (
                  <div key={c.division} style={{ fontSize: 13, opacity: 0.85, marginTop: 4, display: "flex", gap: 6, alignItems: "center" }}>
                    <Trophy size={13} color="#D4A93C" aria-hidden="true" /> {c.division}: {c.team}</div>
                ))}
              </Link>
            ))}
            {!d.tournaments.length && <div style={{ opacity: 0.7 }}>No tournaments yet.</div>}
            <div style={{ marginTop: 30, fontSize: 11, opacity: 0.5, letterSpacing: "0.12em" }}>POWERED BY CHALKOS</div>
          </>
        )}
      </div>
    </div>
  );
}
